import React from 'react';
import { alpha, Box, Collapse, Typography } from '@mui/material';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';

const PHILOSOPHY_CARDS = [
  { icon: <HourglassEmptyIcon />, key: 'accumulation', color: '#0ea5e9' },
  { icon: <VolumeOffIcon />, key: 'dryup', color: '#7c3aed' },
  { icon: <TrendingFlatIcon />, key: 'nearResistance', color: '#f59e0b' },
  { icon: <LocalFireDepartmentIcon />, key: 'trigger', color: '#ef4444' },
];

export default function PreparationPhilosophy({ t, open }) {
  return (
    <Collapse in={open}>
      <Box sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: 'repeat(2, minmax(0, 1fr))', lg: 'repeat(4, minmax(0, 1fr))' },
        gap: 0.75,
        pb: 0.5,
      }}>
        {PHILOSOPHY_CARDS.map((c) => (
          <Box key={c.key} sx={{
            px: 1,
            py: 0.85,
            borderRadius: 1,
            border: `1px solid ${alpha(c.color, 0.14)}`,
            bgcolor: alpha(c.color, 0.03),
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.55, mb: 0.3, color: c.color }}>
              <Box sx={{ display: 'flex', '& svg': { fontSize: 14 } }}>{c.icon}</Box>
              <Typography sx={{ fontWeight: 700, fontSize: '0.72rem', lineHeight: 1.2 }}>{t(`preparation.philosophy.${c.key}.title`)}</Typography>
            </Box>
            <Typography sx={{ fontSize: '0.66rem', color: '#64748b', lineHeight: 1.38 }}>{t(`preparation.philosophy.${c.key}.body`)}</Typography>
          </Box>
        ))}
      </Box>
    </Collapse>
  );
}
